const i = {
  "pipeline-row-group-section__list": "pipeline-row-group-section__list",
  "pipeline-row-group-section__list--tight-gap": "pipeline-row-group-section__list--tight-gap",
  "pipeline-row-group-section__badge": "pipeline-row-group-section__badge",
  "pipeline-row-group-section__visually-hidden": "pipeline-row-group-section__visually-hidden"
};
export {
  i as default
};
